export default __webpack_public_path__ + "static/media/our-values-banner.c6ebd020.png";